import { IncidentStatus } from '@screens/incident/filters/StatusSelection'
import { EtatDesLieuxTypeEnum } from '@api/enum'

export const getManifestationItems = (manifestations: OrderedManifestations) => {
  const manifestationsList: ManifestationResponse[] = [
    ...manifestations.inProgress,
    ...manifestations.incoming,
    ...manifestations.toBeClosed,
  ]

  return manifestationsList
    .map((manif) => ({ name: manif.libelle, id: manif.id }))
    .sort((a, b) => a.name.localeCompare(b.name))
}

export const getActivityItems = (activities: FamilleResponse[]) => {
  return activities
    .filter((a) => !a.parentIdFamille)
    .map((famille) => activities.filter((a) => a.parentIdFamille === famille.id))
    .flat()
    .map((a) => ({ name: a.libelle, id: a.id }))
    .sort((a, b) => a.name.localeCompare(b.name))
}

export const getSpaceAndPackageItems = (places: LocalisationResponse[]) => {
  return places
    .filter((place) => !place.parentId || !!place.package)
    .map((space) => ({ name: space.libelle, id: space.id }))
    .sort((a, b) => a.name.localeCompare(b.name))
}

export const getStatusItems = (status: IncidentStatus[], i18n: I18nState) => {
  return status.map((status) => ({ name: i18n.t(status.name), id: status.id }))
}

export const getCategoryItems = (i18n: I18nState) => {
  return [
    { name: i18n.t('screens.incidentList.filters.type.prestation'), id: 'prestation' },
    { name: i18n.t('screens.incidentList.filters.type.infrastructure'), id: 'infrastructure' },
  ]
}

export const getEDLCategoryItems = (i18n: I18nState) => {
  return [
    { name: i18n.t('screens.edlList.filters.category.manifestation'), id: 'manifestation' },
    { name: i18n.t('screens.edlList.filters.category.tenant'), id: 'tenant' },
  ].sort((a, b) => a.name.localeCompare(b.name))
}

export const getEDLTypeItems = (i18n: I18nState) => {
  return [
    { name: i18n.t('screens.edlList.filters.type.entry'), id: EtatDesLieuxTypeEnum.ENTREE },
    { name: i18n.t('screens.edlList.filters.type.exit'), id: EtatDesLieuxTypeEnum.SORTIE },
  ].sort((a, b) => a.name.localeCompare(b.name))
}
